var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-back fill-height pa-5"},[(_vm.customerId)?_c('AccountBalance',{attrs:{"id":_vm.customerId,"disabled":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }